/**
 * API URL Helper - Runtime only, no process.env
 * 
 * ALL production access goes through nginx which routes /api/ to backend.
 * We ALWAYS use relative URLs in production.
 * 
 * This file intentionally avoids process.env to prevent webpack inlining.
 */

/* eslint-disable no-restricted-globals */
export function getApiUrl() {
  // Force runtime evaluation - webpack cannot optimize window access
  var loc = self.location || window.location;
  var h = (loc.hostname || '').toLowerCase();
  // Only Emergent preview needs absolute URL
  if (h.indexOf('emergentagent.com') > -1) {
    return loc.protocol + '//' + loc.host;
  }
  // All production domains (custom + elsette subdomains) use relative URLs
  return '';
}
/* eslint-enable no-restricted-globals */
